import { useStore } from 'vuex'

import StafetRoundCounter from 'components/StafetRoundCounter/StafetRoundCounter.vue'

export default {
    name: 'StafetRoundCounterAccordion',
    components: { StafetRoundCounter },
    props: {
        participantData: {
            type: Object,
            required: true
        },
        maxRegistrationCount: {
            type: Number,
            required: false
        }
    },

    setup() {
        const store = useStore()

        const toggleAccordion = function (e) {
            const isExpanded = !!(
                e.currentTarget.getAttribute('aria-expanded') === 'true'
            )
            const accordionTarget = document.querySelector(
                `#${e.currentTarget.getAttribute('aria-controls')}`
            )
            const chevronTarget = e.currentTarget.querySelector(
                '.kb-stafet-round-counter-accordion__participant-chevron'
            )

            chevronTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-stafet-round-counter-accordion__participant-chevron--open'
            )
            accordionTarget.classList[isExpanded ? 'remove' : 'add'](
                'kb-stafet-round-counter-accordion__content--open'
            )
            e.currentTarget.setAttribute(
                'aria-expanded',
                isExpanded ? 'false' : 'true'
            )

            accordionTarget.querySelectorAll('a').forEach((a) => {
                if (isExpanded) {
                    a.setAttribute('tabindex', -1)
                } else {
                    a.removeAttribute('tabindex')
                }
            })
        }

        return {
            toggleAccordion,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'roundCounterAccordion',
                    labelKey
                })
        }
    }
}
